import { useServicesContext } from "@/modules/core/services/services.context"
import type { MultipleSetScoreInputDto } from "@/modules/scores/scoreForms/gateway/scoreDto"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export const useScoreActions = () => {
  const { scoreApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: addMultipleScoresToExercise, isPending: isAddMultipleScoresToExercisePending } = useMutation({
    mutationFn: async ({
      programId,
      sessionId,
      exerciseId,
      score,
    }: {
      programId: string
      sessionId: string
      exerciseId: string
      score: MultipleSetScoreInputDto
    }) => {
      return await scoreApi.addMultipleScoresToExercise(programId, sessionId, exerciseId, score)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["programSession"] })
      queryClient.invalidateQueries({ queryKey: ["scoreboard"] })
      queryClient.invalidateQueries({ queryKey: ["myRanking"] })
      queryClient.invalidateQueries({ queryKey: ["athleteScoreboard"] })
    },
  })

  return {
    addMultipleScoresToExercise,
    isAddMultipleScoresToExercisePending,
  }
}
